'use strict';

module.exports = function (value) {
	if (value == null) throw new TypeError("Cannot use null or undefined");
	return value;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es5-ext/object/valid-value.js
 ** module id = 11
 ** module chunks = 0
 **/